export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1920w.1cbe79f1.webp";